import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";

const EditItemModal = ({ deliveryNoteItems, show, onClose, itemData, onChange, full_Item_Detail, onSave, removedSerials, setRemovedSerials }) => {
    console.log(full_Item_Detail, "full_Item_Detail");

    if (!show || !itemData) return null;

    const handleInput = (e) => {
        const { name, value } = e.target;
        onChange({ ...itemData, [name]: value });
    };

    const handleRemoveSerial = (serial, idx) => {
        // Use itemData.serial_no instead of full_Item_Detail.serial_no
        let currentSerials = itemData.serial_no.split("\n");

        // Remove any empty strings that might result from split
        currentSerials = currentSerials.filter(s => s.trim() !== "");

        // Remove the specific serial
        const updatedSerials = currentSerials.filter(s => s !== serial);

        // Calculate how many serials were removed (should be 1 in this case)
        const removedCount = currentSerials.length - updatedSerials.length;

        // For negative quantities, we need to ADD the removed count to make it less negative
        const newQty = itemData.qty + removedCount;
        const newAcceptedQty = itemData.accepted_qty + removedCount;

        // Update the item data - join with \n, no leading/trailing \n
        const newSerialString = updatedSerials.join("\n");

        onChange({
            ...itemData,
            serial_no: newSerialString,
            qty: newQty,
            accepted_qty: newAcceptedQty
        });

        // Store removed serial
        setRemovedSerials(prev => {
            const existingEntry = prev.find(r => r.idx === idx);

            if (existingEntry) {
                if (!existingEntry.serial.includes(serial)) {
                    return prev.map(r =>
                        r.idx === idx
                            ? { ...r, serial: [...r.serial, serial] }
                            : r
                    );
                }
                return prev;
            } else {
                return [...prev, { idx, serial: [serial] }];
            }
        });
    };
    return (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Edit Item</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">

                        {/* Item Details Row */}
                        <div className="row mb-2">
                            <div className="col-6">
                                <Input label="Item Name" value={full_Item_Detail.item_name} readOnly style={{ height: "30px" }} />
                            </div>
                            <div className="col-6">
                                <Input label="Item Code" value={full_Item_Detail.item_code} readOnly style={{ height: "30px" }} />
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col-6">
                                <Input label="Rate" value={full_Item_Detail.rate} readOnly style={{ height: "30px" }} />
                            </div>
                            <div className="col-6">
                                <Input label="Total Amount" value={full_Item_Detail.rate * full_Item_Detail.qty} readOnly style={{ height: "30px" }} />
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col-6">
                                <Input label="UOM" value={full_Item_Detail.uom} readOnly style={{ height: "30px" }} />
                            </div>
                            <div className="col-6">
                                <Input label="Total Qty" value={full_Item_Detail.qty} readOnly style={{ height: "30px" }} />
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col-6">
                                <Input label="Accepted Qty" type="number" name="accepted_qty" value={itemData.accepted_qty} onChange={handleInput} style={{ height: "30px" }} />
                            </div>
                            <div className="col-6">
                                <Input label="Rejected Qty" type="number" name="rejected_qty" value={itemData.rejected_qty} onChange={handleInput} style={{ height: "30px" }} />
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col-6">
                                <Input label="Manufacturing Date" type="date" name="manufacturing_date" value={itemData.manufacturing_date} onChange={handleInput} style={{ height: "30px" }} />
                            </div>
                            <div className="col-6">
                                <Input label="Expiry Date" type="date" name="expiry_date" value={itemData.expiry_date} onChange={handleInput} style={{ height: "30px" }} />
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col-6">
                                <Input label="Batch No." type="text" name="batch_no" value={itemData.batch_no || ""} onChange={handleInput} style={{ height: "30px" }} />
                            </div>
                        </div>

                        {/* Serial Numbers with Remove Option */}
                        <div className="row mb-2">
                            <div className="col-6">
                                <label style={{ fontSize: "0.8rem" }}>Serial No.</label>
                                <div
                                    className="d-flex flex-wrap border p-2"
                                    style={{
                                        borderRadius: "10px",
                                        background: "#f9f9f9",
                                        minHeight: "50px",
                                        gap: "6px",
                                    }}
                                >
                                    {full_Item_Detail.serial_no &&
                                        full_Item_Detail.serial_no
                                            .split("\n")
                                            .filter((serial) => serial.trim() !== "")
                                            .map((serial, index) => {
                                                const isRemoved = removedSerials.some(
                                                    (r) => r.idx === full_Item_Detail.idx && r.serial.includes(serial)
                                                );

                                                if (isRemoved) return null;

                                                return (
                                                    <div
                                                        key={index}
                                                        className="d-flex align-items-center"
                                                        style={{
                                                            background: "#EDEDED",
                                                            borderRadius: "12px",
                                                            padding: "2px 6px",
                                                            fontSize: "0.7rem",
                                                            color: "gray",
                                                            margin: "2px", // spacing between chips
                                                            maxWidth: "150px",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                flex: 1,
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            {serial}
                                                        </span>

                                                        {deliveryNoteItems?.status === "Draft" && (
                                                            <button
                                                                type="button"
                                                                onClick={() => handleRemoveSerial(serial, full_Item_Detail.idx)}
                                                                style={{
                                                                    marginLeft: "6px",
                                                                    background: "white",
                                                                    border: "1px solid #ccc",
                                                                    borderRadius: "50%",
                                                                    width: "16px",
                                                                    height: "16px",
                                                                    fontSize: "10px",
                                                                    lineHeight: "14px",
                                                                    textAlign: "center",
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    padding: 0,
                                                                }}
                                                            >
                                                                ×
                                                            </button>
                                                        )}


                                                    </div>
                                                );
                                            })}

                                </div>
                            </div>
                        </div>


                    </div>
                    {deliveryNoteItems?.status === "Draft" && (
                        <div className="modal-footer">
                            <p
                                style={{ textDecoration: "none", cursor: "pointer" }}
                                className="custom-btn-00989 m-0"
                                onClick={() => onSave()}
                            >
                                Save
                            </p>
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
};

export default EditItemModal;